import * as React from 'react';
import './slidder.css'

import 'video.js/dist/video-js.css';

// interface VideoPlayerPropsInferface {
//   videoJsOptions: videojs.PlayerOptions;
// }

export default class VideoPlayer extends React.Component {
  // private player?: videojs.Player;
  // private videoNode?: HTMLVideoElement;

  // constructor(props: VideoPlayerPropsInferface) {
  //   super(props);
  //   this.player = undefined;
  //   this.videoNode = undefined;
  // }

  // componentDidMount() {

  //   this.player = videojs(this.videoNode, this.props).ready(function() {
  //   });
  // }

  // componentWillUnmount() {
  //   if (this.player) {
  //     this.player.dispose();
  //   }
  // }

  render() {
    return (
      <div className="c-player">
        <div className="c-player__screen" data-vjs-player="true">
          Video 
          {/* <video ref={(node: HTMLVideoElement) => this.videoNode = node} className="video-js" /> */}
        </div>
      </div>
    );
  }
}